import { makeStyles } from 'tss-react/mui';
import { getColors } from '@mercedes-benz/odp-theme-v2';

const useStyles = makeStyles()(theme => {
  const c = getColors(theme.palette.mode);
  const isLight = theme.palette.mode === 'light';
  return {
    root: {
      background: c.background.paper,
      borderRadius: 12,
      border: `1px solid ${c.border.default}`,
      padding: 24,
      minHeight: 400,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12,
      textAlign: 'center',
    },
    icon: {
      fontSize: 40,
      opacity: 0.3,
    },
    title: {
      color: c.text.primary,
      fontWeight: 600,
      fontSize: '1.1rem',
      margin: 0,
    },
    subtitle: {
      color: isLight ? 'rgba(0,0,0,0.45)' : 'rgba(255,255,255,0.4)',
      fontSize: '0.875rem',
      margin: 0,
    },
  };
});

export const SecurityTab = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <span className={classes.icon}>🔒</span>
      <h3 className={classes.title}>Coming Soon</h3>
      <p className={classes.subtitle}>
        Security insights are not yet defined for this view.
      </p>
    </div>
  );
};
